<script >
// import EmergenciesComponent from "@/components/EmergenciesComponent.vue";
// import AddressComponent from "@/components/AddressComponent.vue";
// import AppointmentComponent from "@/components/AppointmentComponent.vue";

import EmergenciesServiceComponent from "@/components/EmergenciesServiceComponent.vue";
import EmergenciesComponent from "@/components/EmergenciesComponent.vue";
import SideContactComponent from "@/components/SideContactComponent.vue";
import AddressComponent from "@/components/AddressComponent.vue";
import AppointmentComponent from "@/components/AppointmentComponent.vue";
import {app} from "@/main";

export default {
  name: "PediatricPage",
  components: {
    AppointmentComponent,
    AddressComponent, SideContactComponent, EmergenciesComponent, EmergenciesServiceComponent},
  data() {
    return {
      locale:'',
      specialties:[6,4,11,36,37,38,39],
      specialists:[],
    };
  },

  mounted() {
    app.config.globalProperties.$emitter.on('languageChanged', (locale) => {
      this.loadData(locale);
    });

  },
  created(){
    let locale = this.$i18n.locale;
    this.locale = locale;
    this.loadData(locale);
  },
  methods:{
    loadData(locale){
      this.specialists = require('../../data/specialists.json');
      this.specialists = this.specialists.filter(s =>
          s.specialties.some(specialty => this.specialties.includes(specialty.id))
      );
      this.specialists = this.specialists.map(specialist => {
        const translateInformation= specialist.information[locale];
        let specialties = specialist.specialties.map(specialty=>{
          const name= specialty.name[locale];
          return {
            ...specialty,
            name:name
          }
        });

        return {
          ...specialist,
          information: translateInformation,
          specialties:specialties
        };
      });

    },
    stringArray(string) {
      return string.split(',');
    },
  }
}
</script>

<template>
  <header class="uui-section_blogpost05-7">
    <div class="uui-page-padding-49">
      <div class="uui-container-large-39">
        <div class="uui-padding-vertical-xhuge-51">
          <div class="w-layout-grid uui-blogpost05_header-7">
            <div id="w-node-dc34c853-8649-f1fb-beeb-54363838d03f-d4f0c0c2" class="uui-blogpost05_title-wrapper-7">
              <div class="uui-space-large-7"></div>
              <div class="uui-button-row-12">
                <router-link data-w-id="dc34c853-8649-f1fb-beeb-54363838d042" to="/" class="uui-button-link-10 w-inline-block">
                  <div class="uui-button-icon-11 w-embed"><svg width="20" height="20" viewbox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.8332 10.0003H4.1665M4.1665 10.0003L9.99984 15.8337M4.1665 10.0003L9.99984 4.16699" stroke="CurrentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg></div>
                  <div>{{$t('home.home')}}</div>
                </router-link>
              </div>
              <h1 class="uui-heading-large-15">{{$t('pediatric-emergencies.pediatric-emergencies-title')}}</h1>
              <div class="uui-space-large-7"></div>
              <address-component></address-component>
            </div>
            <div id="w-node-dc34c853-8649-f1fb-beeb-54363838d04c-d4f0c0c2" class="uui-blogpost05_image-wrapper-7"><img srcset="../../../public/images/MEDICOS-EN-URGENCIAS-p-500.jpg 500w, ../../../public/images/MEDICOS-EN-URGENCIAS-p-800.jpg 800w, ../../../public/images/MEDICOS-EN-URGENCIAS-p-1080.jpg 1080w, ../../../public/images/MEDICOS-EN-URGENCIAS-p-1600.jpg 1600w, ../../../public/images/MEDICOS-EN-URGENCIAS-p-2000.jpg 2000w, ../../../public/images/MEDICOS-EN-URGENCIAS-p-2600.jpg 2600w, ../../../public/images/MEDICOS-EN-URGENCIAS-p-3200.jpg 3200w, ../../../public/images/MEDICOS-EN-URGENCIAS.jpg 6960w" loading="lazy" sizes="(max-width: 479px) 100vw, (max-width: 767px) 96vw, (max-width: 991px) 94vw, (max-width: 1439px) 45vw, (max-width: 1919px) 46vw, 768px" src="../../../public/images/MEDICOS-EN-URGENCIAS.jpg" alt="" class="uui-blogpost03_image-2"></div>
          </div>
          <div class="uui-blogpost05_content-wrapper-8">
            <div class="uui-blogpost05_content-left-2">

              <emergencies-component></emergencies-component>
              <side-contact-component></side-contact-component>
            </div>
            <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1190e4-d4f0c0c2" class="uui-blogpost05_content-2">
              <section class="equipos-mujer">
                <div class="rl-padding-global-20">
                  <div class="rl-container-large-15"></div>
                </div>
              </section>
              <section class="team_seccion">
                <div class="uui-page-padding-18">
                  <div class="uui-container-large-14"></div>
                </div>
              </section>
              <section class="rl_section_layout239-3">
                <div class="rl-padding-global-22">
                  <div class="rl-container-large-17"></div>
                </div>
              </section>
              <section class="uui-section_layout81">
                <div class="uui-page-padding-23">
                  <div class="uui-container-large-19"></div>
                </div>
              </section>
              <header class="uui-section_blogpost06">
                <div class="w-layout-grid uui-blogpost06_header">
                  <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1190f3-d4f0c0c2" class="uui-blogpost06_header-content"><img src="../../../public/images/image-100.png" loading="lazy" alt="" class="image-17">
                    <h1 class="uui-heading-large-8">{{$t('obstetrical.obstetrical-emergency-title')}}</h1>
                    <div class="w-layout-hflex flex-block-20">
                      <div class="w-layout-vflex flex-block-22">
                        <h1 class="heading-8">{{$t('obstetrical.obstetrical-emergency-title-2')}}<br></h1>
                        <div class="w-layout-hflex flex-block-19">
                          <h1 class="heading-15">954 104 2270</h1>
                          <h1 class="heading-16">Ext. 103</h1>
                        </div>
                        <h1 class="heading-17">{{$t('obstetrical.obstetrical-emergency-title-3')}}<br></h1>
                      </div>
                      <div class="w-layout-vflex flex-block-21">
                        <h1 class="heading-8">{{$t('obstetrical.obstetrical-emergency-title-4')}} (AUX)<br></h1>
                        <div class="w-layout-hflex flex-block-19">
                          <h1 class="heading-15">954 104 2270</h1>
                          <h1 class="heading-16">Ext. 104</h1>
                        </div>
                        <h1 class="heading-17">{{$t('obstetrical.obstetrical-emergency-title-3')}}<br></h1>
                      </div>
                    </div>
                  </div>
                </div>
                <header class="uui-blogpost06_content-wrapper">
                  <div class="uui-page-padding-24">
                    <div class="uui-container-large-19">
                      <div class="uui-padding-vertical-xhuge-26">
                        <div class="div-block-11">
                          <h4 class="heading-10">{{$t('pediatric-emergencies.pediatric-emergencies-p1')}}</h4>
                          <ul role="list" class="list">
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p2')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p3')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p4')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p5')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p6')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p7')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p8')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p9')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p10')}}</li>
                            <li>{{$t('pediatric-emergencies.pediatric-emergencies-p11')}}</li>
                          </ul>
                        </div>
                        <div class="uui-max-width-large-12 align-center">
                          <div class="uui-blogpost06_content">
                            <div class="div-block-12">
                              <h4 class="heading-10">{{$t('pediatric-emergencies.pediatric-emergencies-p12')}}</h4>
                              <ul role="list" class="list">
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p13')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p14')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p15')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p16')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p17')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p18')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p19')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p20')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p21')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p22')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p23')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p24')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p25')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p26')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p27')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p28')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p29')}}</li>
                                <li>{{$t('pediatric-emergencies.pediatric-emergencies-p30')}}</li>
                              </ul>
                            </div>
                            <div class="uui-blogpost06_rich-text-divider"></div>
                            <div class="text-block-20"><strong><em class="italic-text">&quot;{{$t('pediatric-emergencies.pediatric-emergencies-p31')}}&quot;</em></strong></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </header>
              <section class="team_seccion">
                <div class="uui-page-padding-18">
                  <div class="uui-container-large-14">
                    <div class="uui-padding-vertical-xhuge-20">
                      <div class="uui-max-width-large-9">
                        <h2 class="uui-heading-medium-11" style="margin-top: 2rem;margin-bottom: 2rem; text-align: center;color: var(--hc--colors--green--600);">{{$t('home.emergencies-aid')}}</h2>
                        <h2 class="uui-heading-medium-11">{{$t('home.our-team')}}</h2>
                        <div class="uui-space-xsmall-10"></div>
                      </div>
                      <div class="uui-team07_component-2">
                        <div class="uui-team07_list-wrapper-2">
                          <div class="w-layout-grid item_medico">
<!--                            <div  v-for="(item, index) in specialists" :key="index" class="card_doctor">-->
<!--                              <div class="uui-team07_image-wrapper-2"><img v-bind:src="item.profile_picture" loading="lazy" sizes="84px"  alt="" class="uui-team07_image-2"></div>-->
<!--                              <div class="uui-team07_item-content-2">-->
<!--                                <div class="uui-heading-tiny-4">{{item.name}}</div>-->
<!--                                <div v-if="item.professional_license.length"  class="uui-text-size-medium-15 text-color-primary700">Ced. Prof. {{item.professional_license}}</div>-->
<!--                                <div v-if="item.specialty_license.length">-->
<!--                                  <div  v-for="(spe, i) in stringArray(item.specialty_license)" :key="i"  class="uui-text-size-medium-15 text-color-primary700">Ced. Esp. {{spe}} </div>-->
<!--                                </div>-->
<!--                                <div class="uui-space-xxsmall-8"></div>-->
<!--                                <div class="uui-text-size-medium-15">-->
<!--                                  <strong v-for="(specialty, index) in item.specialties" :key="index">{{specialty.name}} <br></strong>-->
<!--                                  {{item.information}}-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c11916a-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO.jpg" loading="lazy" sizes="84px" srcset="../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-500.jpg 500w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-800.jpg 800w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-1080.jpg 1080w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-1600.jpg 1600w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-2000.jpg 2000w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-2600.jpg 2600w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO-p-3200.jpg 3200w, ../../../public/images/DR.-IRWIN-REY-POBLETE-PINACHO.jpg 6000w" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. Irwin Rey Poblete Pinacho</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced. Prof. 6546931<br>Ced. de Esp. 12900505</div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Médico Urgenciologo.<br></strong><span>Hospital General Regional 196, Fidel Velasquez Sánchez Ecatepec de Morelos, Universidad: Instituto Politécnico Nacional.</span></div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c11917b-d4f0c0c2" class="uui-team07_image-wrapper-2"><img  src="../../../public/images/luis-alberto-manriquez.png" loading="lazy" sizes="84px" srcset="../../../public/images/luis-alberto-manriquez-p-500.png 500w, ../../../public/images/luis-alberto-manriquez-p-800.png 800w, ../../../public/images/luis-alberto-manriquez-p-1080.png 1080w, ../../../public/images/luis-alberto-manriquez-p-1080.png 1600w, ../../../public/images/luis-alberto-manriquez-p-1080.png 2000w, ../../../public/images/luis-alberto-manriquez-p-1080.png 2600w, ../../../public/images/luis-alberto-manriquez-p-1080.png 3200w, ../../../public/images/luis-alberto-manriquez.png 4000w" alt="" class="uui-team07_image-2" ></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. Luis Alberto Manríquez Santos</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced. Prof. 4644596<br>Ced. de Esp. 6323680</div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Pediatría.</strong><br>Posgrado en la Universidad Nacional Autónoma de México H.G. Darío Fernández Fierro ISSSTE Certificado por el Consejo de Certificación en Pediatría No 15498</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c11918b-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/maythe-narda.png" loading="lazy" sizes="84px" srcset="../../../public/images/maythe-narda-p-500.png 500w, ../../../public/images/maythe-narda-p-800.png 800w, ../../../public/images/maythe-narda-p-1080.png 1080w, ../../../public/images/maythe-narda-p-1080.png 1600w, ../../../public/images/maythe-narda-p-1080.png 2000w, ../../../public/images/maythe-narda-p-1080.png 2600w, ../../../public/images/maythe-narda-p-1080.png 3200w, ../../../public/images/maythe-narda-p-1080.png 4000w" alt="" class="uui-team07_image-2 maythe"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dra. Maythe Narda Hernández García</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced. Prof. 6792224<br>Ced. de Esp. 9714459</div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Pediatría.</strong><br>Certificada por el Colegio Mexicano de Pediatría No 18962.</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c11919b-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ.jpg" loading="lazy" sizes="84px" srcset="../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-500.jpg 500w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-800.jpg 800w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-1080.jpg 1080w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-1600.jpg 1600w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-2000.jpg 2000w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-2600.jpg 2600w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ-p-3200.jpg 3200w, ../../../public/images/DR.-ARMANDO-DOMINGUEZ-GONZALEZ.jpg 6000w" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. Armando Domínguez González</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced. Prof. 9456145<br></div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Pediatría.</strong><br>Egresado de la U.A.B.J.O, Hospital del Niño, Dif Hidalgo – UAEH, Certificado por el Colegio Mexicano de Pediatría No. 18797 , Miembro del Colegio de Pediatría de Oaxaca.</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1191ab-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/DR.-ALEX-TONY-REYES-SANTIAGO-CIRUJANO-ONCOLOGO-PEDIATRA-1.jpeg" loading="lazy" sizes="84px" srcset="../../../public/images/DR.-ALEX-TONY-REYES-SANTIAGO-CIRUJANO-ONCOLOGO-PEDIATRA-1-p-500.jpeg 500w, ../../../public/images/DR.-ALEX-TONY-REYES-SANTIAGO-CIRUJANO-ONCOLOGO-PEDIATRA-1-p-800.jpeg 800w, ../../../public/images/DR.-ALEX-TONY-REYES-SANTIAGO-CIRUJANO-ONCOLOGO-PEDIATRA-1.jpeg 1200w" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. Alex Tony Reyes Santiago</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced Prof. 5399716<br>Ced Esp. 9177508<br></div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Cirujano Oncólogo Pediatra.<br></strong>Hospital Infantil de Mexico Federico Gomez. Cirugía Oncológica Pediatría, UNAM, Médico Cirujano UABJO, Cirujano Pediatra UNAM.</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1191bc-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/doc.png" loading="lazy" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. César Augusto Zárate Morales</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced Prof. 1872220<br>Ced Eso 3392103<br></div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Cardiología Pediátrica.</strong><br>Hospital Infantil de México Federico Gómez, UNAM.</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1191cd-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/dr.alberto-molina-peto.jpg" loading="lazy" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. Alberto Molina Peto</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced Prof. 10002907<br>Ced Esp. 10531813<br></div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Gastroenterólogo Pediatra.<br>‍</strong>Médico Cirujano por la Universidad Autónoma Benito Juárez de Oaxaca, Especialidad en Gastroenterología y Nutrición Pediátrica por la Universidad Nacional Autónoma de México, Formación en la UMAE Hospital de Pediatría del Centro Médico Nacional Siglo XXI en la Ciudad de México y por la UNAM.</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1191df-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/dra.Kenia-cruz-calvo-neurologa-pediatra.png" loading="lazy" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dra. Kenia Cruz Calvo</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced Prof. 6230372<br>Ced Esp. 10996304<br></div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Neurologa Pediatra.<br></strong>UPAEP UNAM, Certificada por el Consejo Mexicano de Pediatría, Certificada por el Consejo Mexicano de Neurología.</div>
                              </div>
                            </div>
                            <div class="card_doctor">
                              <div id="w-node-ffb2e842-b995-a3c7-4d02-c4792c1191f0-d4f0c0c2" class="uui-team07_image-wrapper-2"><img src="../../../public/images/doc.png" loading="lazy" alt="" class="uui-team07_image-2"></div>
                              <div class="uui-team07_item-content-2">
                                <div class="uui-heading-tiny-4">Dr. Francisco Javier Martínez</div>
                                <div class="uui-text-size-medium-15 text-color-primary700">Ced Prof. 8043480<br>Ced Esp. 11482794<br></div>
                                <div class="uui-space-xxsmall-8"></div>
                                <div class="uui-text-size-medium-15"><strong>Traumatólogo Pediátrica.<br></strong>UNAM/Hospital Shriners para Niños México.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <appointment-component></appointment-component>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <section class="uui-section_blogsection02-2">
            <div class="uui-page-padding-43">
              <div class="uui-container-large-33">
                <div class="uui-padding-vertical-xhuge-44">
                  <div class="uui-text-align-center-15">
                    <div class="uui-max-width-large-20 align-center">
                      <h2 class="uui-heading-medium-28">Servicio de Urgencias</h2>
                      <div class="uui-space-xsmall-22"></div>
                      <div class="uui-text-size-large-31">El Servicio de Urgencias del Hospital Ángel del Mar te ofrece atención médica oportuna, profesional y ética las 24 horas del día, los 365 días del año, con médicos urgenciologos y con respaldo de más de 65 especialistas , con estudios de imágen y gabinete; 2 áreas de choque equipadas y acceso de costado rápido.</div>
                    </div>
                  </div>
                  <emergencies-service-component></emergencies-service-component>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>

</style>
